/* eslint-disable @typescript-eslint/naming-convention */
import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { Data } from "../../../store/usergroup/types";
import TableActions from "../../../common/table/TableActions";
import { MRT_ColumnDef, MaterialReactTable } from "material-react-table";

interface Props {
  userGroup?: Data[];
}

interface RowData {
  id: string;
  name: string;
}

const mapDataToTable = (userGroups: Data[]): RowData[] => {
  return userGroups.map((data) => {
    return {
      id: data.id,
      name: data.attributes.Name,
    };
  });
};

export default function UserGroupTable({ userGroup }: Props) {
  const history = useHistory();
  const [err, setErr] = useState({
    code: null,
    title: "",
  });
  const [currentId, setCurrentId] = useState<string | null>(null);

  const editAction = (rowData: RowData) => {
    history.push(`/role/edit/${rowData.id}`);
  };

  const viewAction = (rowData: RowData) => {
    history.push(`/role/view/${rowData.id}`);
  };

  useEffect(() => {
    return () => {
      setCurrentId(null);
      setErr(null);
    };
  }, []);

  const data = mapDataToTable(userGroup);

  const columns = useMemo<MRT_ColumnDef<RowData>[]>(
    () => [
      {
        header: "Name",
        accessorKey: "name",
      },
    ],
    []
  );

  return (
    <>
      <MaterialReactTable
        columns={columns}
        data={data}
        getRowId={(row) => row.id}
        initialState={{
          showGlobalFilter: true,
          showColumnFilters: false,
          density: "spacious",
        }}
        enableColumnActions={false}
        enableDensityToggle={false}
        enableFullScreenToggle={false}
        enableColumnFilters={false}
        enableHiding={false}
        enableRowActions
        muiTablePaginationProps={{
          rowsPerPageOptions: [5, 10, 20],
        }}
        displayColumnDefOptions={{
          "mrt-row-actions": {
            header: "",
            size: 100,
          },
        }}
        positionActionsColumn="last"
        renderRowActions={({ row }) => (
          <TableActions
            section="UserGroup"
            onView={() => viewAction(row.original)}
            onEdit={() => editAction(row.original)}
          />
        )}
      />
    </>
  );
}
